export default __webpack_public_path__ + "static/thor-be3885a673e4d34836d627968d74aa49.png";